module.exports = __webpack_public_path__ + "static/media/github.8c02b1be.svg";